import React from 'react';

const LeadInfoField = ({ label, value, className = '' }) => {
  return (
    <div className={className}>
      <label className="text-sm text-muted-foreground mb-1 block">{label}</label>
      <p className="text-foreground font-medium break-words">{value || 'N/A'}</p>
    </div>
  );
};

export default LeadInfoField;